import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_GATEWAY_URL } from '../../config/constants';
import axios from 'axios';
import UserHelper from '../../common/utils/userHelper';
import { getImage ,getVideo} from '../../common/utils/eventHelper';
import { highlightTitle } from '../../utils/htmlHelper';


interface AboutProps {
    landingPageData: any; 
    label: string;
          
  }
 
const Gallery:React.FC <AboutProps> = ({landingPageData,label}) => {
  const eventId = UserHelper.getEventId();
  const [data, setData] = useState<any>();
  const eventData = useSelector((state: any) => state.eventData, shallowEqual);
  
  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const res = await axios.get(
          `${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}/gallery`
        );
        console.log('Gallery page data:', res.data.data);
        setData(res.data.data[0]?.asset_file || []);
      } catch (error) {
        console.error('Error fetching gallery page data:', error);
      }
    };

    fetchGalleryData();
  }, [eventId]);

  const settings = {
    // dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,           // 👈 Enable auto sliding
    autoplaySpeed: 2000,      // 👈 3 seconds interval
    arrows: false,
  };

  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }
  const text = landingPageData?.event_galary_text || '';
  const eventTitle = eventData?.title || '';

  
  return (
    <div className="single-section gallery-area pt-0" id="gallery">
      <div className="container">
        <div className="section-heading">
          <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>{label}</h2>
          <p className="section-description col-lg-12 col-md-10 col-sm-12">
            {highlightTitle(text, eventTitle)}
          </p>
        </div>

        <Slider {...settings}>
          {data?.length > 0 ? (
            data.map((src:any, index:any) => (
              <div key={index} className="img-slide text-center">
                <img
                  src={getImage(src)}
                  alt={`Slide ${index + 1}`}
                  style={{ width: '350px', height: '300px', borderRadius: '12px' }}
                />
              </div>
            ))
          ) : (
            <p>No images to display</p>
          )}
        </Slider>
      </div>
    </div>

  );
};

export default Gallery;
